module.exports = __webpack_public_path__ + "static/lars-8521ffad81f1cb9d97b280d94d2a2374.png";